/* eslint-disable @typescript-eslint/no-unused-vars */

export function getApiUrl() {
  if (import.meta.env.VITE_API_BASE_URL === 'auto') {
    try {
      if (window.location.hostname.endsWith('.tekst.ai')) {
        return 'https://api.tekst.ai';
      }
      if (window.location.hostname.endsWith('.tekst.com')) {
        return 'https://api.tekst.com';
      }
      if (window.location.hostname.includes('localhost')) {
        return 'http://localhost:8000';
      }
      return 'https://api.tekst.ai';
    } catch (err) {
      return 'https://api.tekst.ai';
    }
  }
  return import.meta.env.VITE_API_BASE_URL;
}
